export const gaCategories = Object.freeze({
  board : 'Board',
});

export const gaActions = Object.freeze({
  create : 'create',
  join   : 'join',
});

export const gaLabels = Object.freeze({
  ok : 'ok',
  ko : 'ko',
});
